<template>
  <v-app>
    <v-app-bar
      app
      dark
      :extended="isLoggedIn"
    >
      <v-toolbar-title>
        <h1 class="huemix-title">
          Hümix
          <span class="title font-italic white--text">manage</span>
        </h1>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text href="https://huemix.de" target="new">
        huemix.de <v-icon small>mdi-open-in-new</v-icon>
      </v-btn>

      <v-menu offset-y v-if="isLoggedIn">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text dark outlined>
            {{ $store.state.user.username }}
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logout">
            <v-list-item-title>Ausloggen</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <template v-slot:extension v-if="isLoggedIn">
        <v-tabs
          v-model="tab"
          align-with-title
        >
          <v-tab :to="{ name: 'home' }">Übersicht</v-tab>
          <v-tab exact :to="{ name: 'products' }">Produkte</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'App',
  computed: {
    ...mapGetters(["isLoggedIn"])
  },
  data: () => ({
    tab: null
  }),
  methods: {
    async logout() {
      try {
        await this.$store.dispatch("logout");
        this.$router.push({ name: "login" });
      } catch (e) {
        alert("Fehler beim Abmelden: " + e.message)
      }
    }
  }
};
</script>

<style>
.huemix-title {
  font-family: Harlowsi;
  color: red;
}

@font-face {
  font-family: "Harlowsi";
  src: url("assets/fonts/HARLOWSI.TTF");
}
</style>
